import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    group: {},
    permissions: [],
    roleAllocations: [],
  },
  token: "",
  plans: {}
};

const unoUserSlice = createSlice({
  name: "unoUserSlice",
  initialState,
  reducers: {
    saveUserData: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    saveUserPlan:(state,action)=>{
      state.plans= action.payload
    },
    removeUser: (state) => {
      state.user = {};
      state.token = "";
    },
  },
});

export const { saveUserData, removeUser, saveUserPlan } = unoUserSlice.actions;
export default unoUserSlice.reducer;
